import { Breadcrumb } from 'antd';
import * as React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { initPageNamesConfig } from '../../tools/utils';

class Breads extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNamesConfig: {}, // 页面字段配置
      pageLoading: true
    }
  }
  componentDidMount() {
    // 初始化页面展示字段（合作案）
    initPageNamesConfig('crumb', '', this.props.token).then(res => {
      if (res.data.status === 200) {
        this.setState({ pageNamesConfig: res.data.data || {} })
      }
    }).finally(() => {
      this.setState({ pageLoading: false })
    })
  }

  initCrumbMaps = () => {
    return {
      '/manager': '基本法管理',
      '/manager/editModel': '编辑基本法',
      '/importData': '数据导入',

      '/resultConfig': '计算结果配置',
      '/resultConfig/new': '创建模板',
      '/resultConfig/edit': '编辑模板',

      '/calculation': '薪资计算器',
      '/bonusDetail': '奖金明细查询',
      '/addMinusMoney': '加扣款管理',
      '/orgList': '商户列表',
      '/orgList/add': '新增商户',
      '/orgList/edit': '编辑商户',
      '/orgList/template': '模板授权',
      '/orgList/detail': '查看商户',
      '/partner': '商务合伙人',
      '/partner/add': '新增商务合伙人',
      '/partner/detail': '商务合伙人详情',
      '/bidCoefficient': '折标系数配置',


      '/clientAnalyze': '客户分析',
      '/clientManage': '客户管理',
      '/clientManage/detail': '客户详情',

      '/productList': '产品列表',
      '/productShelf': '货架管理',
      '/productShelf/detail/applyProduct': '产品申请',
      '/productUpLine': '产品上下架',
      '/productUpLine/productionInformation': '产品资料',
      '/productUpLine/qrcode': '二维码',
      '/productComparisonAdmin': '产品对比管理',
      '/productComparison': '产品对比管理',
      '/planBookConfigAdmin': '商户计划书管理',
      '/productComparisonAdmin/comparisonConfig': '产品对比配置',
      '/planBookConfigAdmin/selectPlan': '商户计划书配置',
      '/planBookList': '计划书列表',
      '/trussanImport': '产品编辑导入',

      '/mechanismFee': '商户佣金配置',
      '/mechanismFee/add': '新建商户佣金配置',
      '/agentFee': '代理人佣金配置',
      '/agentFee/log': '历史操作记录',
      '/orgRate': '机构费率配置',
      '/orgRate/log': '机构费率操作记录',
      '/salesmanRate': '业务员费率配置',
      '/salesmanRate/log': '业务员费率操作记录',
      '/promotionOrg': '机构推广费配置',
      '/promotionOrg/detail': '详情',
      '/promotionOrg/log': '操作记录',
      '/promotionSalesman': this.state.pageNamesConfig.promotionSalesman || '业务员推广费配置',
      '/promotionSalesman/detail': '详情',
      '/promotionSalesman/log': '操作记录',

      /*财务结算*/
      '/incomeDetail': '收入明细',
      '/salesman': '业务员结算',
      '/orgSettlement': '机构结算',
      '/tenant': '商户佣金结算',
      '/promotion': '推广费收入管理',
      '/promotion/detail': '推广费明细',
      '/myIncome': '我的收入',
      '/myIncome/withDrawApply': '提现申请',
      '/myIncome/withDrawDetail': '提现详情',
      '/myIncome/withDrawApply/withDrawSuccess': '提现成功',
      '/agentCashApply': '业务员提现审核',
      '/continueRate': '续期继续率',
      '/export/exportFile': '导出报表',

      '/rankList': '职级列表',

      '/companyManager': '机构管理',
      '/channelManager': '渠道管理',
      '/companyManager/newCompany': '新建机构',
      '/companyManager/prodControl': '产品管理',
      '/salesManager': this.state.pageNamesConfig.salesManager || '业务员管理',
      '/salesManager/add': this.state.pageNamesConfig.salesManager_add || '新增业务员',
      '/salesManager/add_traditional': '新增业务员',
      '/salesManager/detail_traditional': '业务员详情',
      '/salesManager/detail': '业务员详情',
      '/salesManager/qrcode': '二维码',
      '/groupManager': this.state.pageNamesConfig.groupManager || '团队管理',
      '/groupManager_v2': '团队管理',
      '/groupManager/add': '新增团队',
      '/groupManager/detail': this.state.pageNamesConfig.groupManager_detail || '团队详情',
      '/groupManager/newGroup': '新建团队',
      '/peopleList': '人员管理',
      '/peopleList/add': '新增人员',
      '/peopleList/edit': '编辑人员信息',
      '/companyLevel': '机构级别定义',
      '/salesQualification': '销售资质',

      '/noticeMessage': '系统公告管理',
      '/productInfoList': '产品资料',

      '/editPassword': '修改密码',


      '/permission': '菜单管理',
      '/permission/add': '新增菜单',
      '/permission/detail': '菜单详情',
      '/attendance': '考勤管理',
      '/attendance2': '考勤管理',
      '/attendanceStatistics': '考勤统计',
      '/attendanceProject': '考勤项目',
      '/attendanceProject/add': '新增',

      '/offlinePolicy': '线下保单',
      '/offlinePolicy/add': '新增保单',
      '/offlinePolicy/edit': '编辑保单',
      '/offlinePolicy/detail': '保单详情',

      '/matchTrading': '撮合交易',
      '/matchTrading/add': '新增保单',
      '/matchTrading/edit': '编辑保单',
      '/matchTrading/detail': '保单详情',

      '/getMallLink': '获取商城链接',

    //   "/longOrder": "投保单",
      "/orderplatform": "平台线上订单",
      "/orderplatform/proposalOrderDetail": "平台线上订单详情",
      "/policySys/policyAdmin": "平台线上保单",
      "/policySys/policyAdmin/policyOrderDetailPlatform": "平台保单详情",
      '/noticeList': '系统消息列表',
      "/businessReport/agentReport": "业务员业务统计",
      "/businessReport/insureOrgReport": "保险公司业务统计",
      "/businessReport/spuReport": "产品业务统计",
      "/businessReport/spuReportM": "保险产品业务统计",
      "/businessReport/spuReportM/detail": "产品业务详情",
      "/businessReport/addPeople": "业务员增员统计",
      "/businessReport/orgReport": "机构业务统计",
      "/businessReport/orgReportM": "机构人员业务统计",
      "/businessReport/orgReportM/detail": "业务详情",
      "/businessReport/report": "报表",
      "/businessReport/orgBusinessStatictics": "商户业务统计",
      "/billTrans": "结算单转换",
      "/orderDetail": "详情",
      "/longOrder/proposalOrderDetail": "订单详情",
      "/longOrder/policyOrderDetail": "保单详情",
      "/longOrderAdmin/policyOrderDetailPlatform": "平台保单详情",
      "/shortOrder/proposalOrderDetail": "订单详情",
      "/shortOrder/policyOrderDetail": "保单详情",
      "/accountSafety": "账号安全",
      // "/childAccountManage": "子账号管理",
      "/accountManage": "账号管理",
      "/invManage": "自媒体账号管理",
      "/accountManage/add": "新增账号",
      "/accountManage/detail": "账号详情",
      "/accountManage/permission": "角色授权",
      "/roleMannagers": "角色管理",
      "/roleMannagers/add": "新增角色",
      "/roleMannagers/detail": "角色详情",
      "/persistRate": "机构继续率",
      "/salesMan": "业务员继续率",
      "/insuranceCompany": "保险公司继续率",
      "/submit": "结算单保单",
      "/weitoubao": "商户属性配置",
      "/withDraw": "提现申请管理",
      "/orgFinancialReport": "机构财务报表",
      "/salesmanFinancialReport": "业务员财务报表",
      "/cashStatus": "业务员提现状态查询",
      "/policySys/longOrder": "线上保单",
      "/policySys/submit": "结算单保单",
      "/policySys/longOrder/policyOrderDetail": "保单详情",
      "/policySys/freeOrder": "赠险列表",
      "/policySys/freeOrderDetail": "赠险详情",
      "/policySys/freeOrderSystem": "赠险列表",
      "/policySys/freeOrderSystemDetail": "赠险详情",
      "/editProduct": "自定义产品管理",
      "/editProduct/add": "新增自定义产品",
      "/editProduct/edit": "编辑自定义产品",
      "/shopAdorn": "展业端配置",
      "/shopAdorn/adorn": "展示工具自定义",
      "/policySys/cancelPolicy": "保单撤单",
      "/productMaintain/list": "产品维护通知",
      "/productMaintain/list/add": "新增产品维护通知",
      "/productMaintain/list/edit": "编辑产品维护通知",
      '/withdrawNew': '提现申请管理',
      '/orgnizationList': '组织机构',
      '/orgnizationList/prodControl': '产品上下架',
      '/orgnizationList/qrcode': '二维码',
      '/activitylist': '活动管理',
      '/activitylist/detail': '详情',
      "/reserveOrder": "撤销订单",
      "/replenishment": "补单",
      "/replenishment/detail": "补单详情",
      "/replenishment/proposalOrderDetail": "订单详情",
      "/reserveOrder/detail": "撤销订单详情",
      "/activityReward": "业务员推荐奖励",
      "/policySys/policyContinue": "续期保单管理",
      "/policySys/policyContinue/detail": "保单详情",
      "/policySettlement": "业务员收入发放",//"保单结算管理",
      "/policySettlement/detail": "保单详情",
      "/policySys/policyRenewal": "续保保单管理",
      "/policySys/policyRenewal/detail": "保单详情",
      "/productRepository": "产品库",
      "/storeProduct":"产品库",
      "/productRepository/haltList": "已停售产品",
      "/productRepository/detail": "详情",
      "/productRepository/qrcode": "二维码",
      "/productRepository/specialAgreement": "产品上架前置规则",
      "/productRepository/productionInformation": "产品资料",
      "/underwriting": "闪电核",
      "/commission": "推广费配置",
      "/commission/template": "模板详情",
      "/commission/haltList": "已停售产品",
      "/commission/detail": "推广费详情",
      // 产品管理-推广费模板
      "/feeTemplate": "推广费模板",
      "/feeTemplate/detail": "模板详情",
      "/feeTemplate/detail/haltList": "已停售产品",
      "/feeTemplate/detail/product": "产品详情",
      "/haltSalesList": "已停售产品",
      "/haltSalesList/detail": "产品详情",
      "/policySys": "保单管理",
      "/policySys/onlinePolicy/new": "新单管理",
      "/policySys/onlinePolicy/long": "长险续期",
      "/policySys/orderPolicy": "订单管理",
      "/policySys/appointPolicy": "预约投保单",
      "/policySys/onlinePolicy/short": "短险续保",
      "/policySys/onlinePolicy/records": "导入记录",
      "/policySys/returnVisit": "回执回访",
      // "/policySys/exportFile": "导出报表",
      "/policySys/onlinePolicy/detail": "保单详情",
      // 团险
      '/groupProduct': '团险产品列表',
      '/groupOrder': '团险订单列表',
      '/groupRecording': '团险录单',
      '/preservationSys/preservation': '保全管理',
      '/preservationSys/preservation/detail': '保全详情',
      '/salesmanTrain': '业务员培训',
      '/salesmanTrain/add': '详情',
    };
  }

  render() {
    const { location } = this.props;
    const breadcrumbNameMap = this.initCrumbMaps();
    const pathSnippets = location.pathname.split('/').filter(i => i);
    const reg = /^-?(0|[1-9][0-9]*)(\.[0-9]*)?$/;
    pathSnippets.forEach((ele, index) => {

      if ((!isNaN(ele) && reg.test(ele))) {
        pathSnippets.splice(index, 1);
      }

      if (ele.split('?')[1]) {
        pathSnippets.splice(index, 1);
      }
      if (ele.indexOf("?") > -1) {
        pathSnippets.splice(index, 1);

      }

      if ("newCompany" === ele) {
        pathSnippets.length = index + 1;
      }
      // if (!parseFloat(ele) && typeof parseFloat(ele) === 'number') {
      //   // pathSnippets.splice(index, 1)
      // } else {
      //   pathSnippets.splice(index, 1);
      // }
    });

    const extraBreadcrumbItems =
      this.state.pageLoading ? '' :
        pathSnippets.map((_, index) => {

          const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
          if ("finance" === _) {
            return []
          }
          if (!breadcrumbNameMap[url]) {
            return [];
          }
          return (
            <Breadcrumb.Item key={url}>
              <Link replace
                className={index === pathSnippets.length - 1 ? 'hidden_color' : 'show_color'}
                // to={(index === pathSnippets.length - 1)?url:()=>{return;}}
                to={this.props.disabled ? {} : url}
              >
                {breadcrumbNameMap[url]}
              </Link>
            </Breadcrumb.Item>
          );
        });
    const breadcrumbItems = [(
      <Breadcrumb.Item key="home">
        <a className='show_color' href="#/homePage">首页</a>
      </Breadcrumb.Item>
    )].concat(extraBreadcrumbItems);
    return (
      <Breadcrumb style={{ position: 'absolute', left: 16, top: -40 }}>
        {breadcrumbItems}
      </Breadcrumb>
    )
  }
}

export default withRouter(Breads)
